import { LearnMoreLink, SectionDemoLink } from '../CTAButtons/CTAButtons';
import { routes } from '../../config/links';
import { howItWorksSteps } from '../../data/howItWorks';
import styles from './HowItWorks.module.css';

function HowItWorks() {
  return (
    <section id="how-it-works" className="section" aria-labelledby="how-it-works-heading">
      <div className="container">
        <span className="sectionLabel">How it works</span>
        <h2 id="how-it-works-heading" className="sectionTitle">
          From fan scan to seat delivery in four steps
        </h2>
        <p className="sectionSubtitle">
          ONI connects the in-seat fan experience with the tools your venue team needs to fulfill every order at scale.
        </p>

        <ol className={styles.steps}>
          {howItWorksSteps.map((step) => (
            <li key={step.number} className={styles.step}>
              <span className={styles.number}>{step.number}</span>
              <div>
                <h3 className={styles.title}>{step.title}</h3>
                <p className={styles.description}>{step.description}</p>
              </div>
            </li>
          ))}
        </ol>
        <div className={styles.links}>
          <LearnMoreLink to={routes.howItWorks} label="See the full process →" />
          <SectionDemoLink />
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
